import type { CalculatedOrderDiscounts } from "../CalculatedOrderDiscounts.js";
import type { CountrySettings } from "../CountrySettings.js";
import type { Coupon } from "../Coupon.js";
import type { Customer } from "../Customer.js";
import type { OrderInput } from "../Order.js";
import type { Subcategory } from "../Subcategory.js";
import { calculateFathersFamilyDiscounts } from "./calculateFathersFamilyDiscounts.js";
import { calculateOrderDiscountsFromCoupons } from "./calculateOrderDiscountsFromCoupons.js";
import { getCustomerType } from "./getCustomerType.js";
import { hasOrderFreeDelivery } from "./hasOrderFreeDelivery.js";

interface OrderDiscountSettings {
	customer: Customer | null;
	coupons: Coupon[];
	countrySettings: CountrySettings[];
	subcategories: Pick<Subcategory, "id" | "eligibleForB2cDiscount" | "urlSlug">[];
}

export function calculateOrderDiscounts(
	order: Pick<OrderInput, "products" | "deliveryAddress" | "couponCode">,
	{ customer, countrySettings, subcategories, coupons }: OrderDiscountSettings,
): CalculatedOrderDiscounts {
	const customerType = getCustomerType(customer?.pricingLevel);

	const couponDiscounts = calculateOrderDiscountsFromCoupons(order, customerType, subcategories, coupons);
	const fathersFamilyDiscounts = calculateFathersFamilyDiscounts(order, customer, subcategories);

	return {
		discountsByTaxRate: couponDiscounts.length === 0 ? fathersFamilyDiscounts.discountsByTaxRate : couponDiscounts,
		freeDelivery: hasOrderFreeDelivery(order, countrySettings, customer) || fathersFamilyDiscounts.freeDelivery,
	};
}
